/**
 * Phoenix oprávnění pro akce v tlačítku „Nástroje" (zrcadlí backend `ToolsPermissions`).
 * Viditelnost položek se řídí těmito oprávněními (z `getMe`), takže tlačítko i jeho položky jsou
 * známé hned po přihlášení — nečeká se na načtení Magicu. Akce, které ke svému provedení potřebují
 * Magic, zůstávají do jeho načtení jen disabled (viz DesktopToolsButton).
 *
 * Dev-ops (Stavy démonů, Restart, Ukončit démony) oprávnění nemají — jsou dostupné automaticky
 * v Development prostředí (řídí se `environmentName` z `getDevelopmentDatabaseInfo`).
 */
export const TOOLS_PERMISSIONS = {
  /** Logy. */
  logs: 'tools.logs',
  /** Debug a Debug konzole. */
  debug: 'tools.debug',
  /** Vyprázdnit web-content keše. */
  cache: 'tools.cache',
  /** Obnovit keš oprávnění (čistě Phoenix akce, nezávislá na Magicu). */
  refreshPermissions: 'tools.refresh-permissions',
} as const;
